export const cleanMessage = (message: string) => message.replace(/: .+$/, '');
